function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup, Stack, styled, Typography } from '@mui/material';
import { stringToBoolean } from '@procom-labs/common';
import { useHookFieldError } from '../../hooks';
// Todo: Move to shared location
var CustomFormLabel = styled(FormLabel)(function(param) {
    var theme = param.theme;
    return {
        color: theme.palette.text.primary,
        marginBottom: '1rem'
    };
});
export var RadioGroupValueType = /*#__PURE__*/ function(RadioGroupValueType) {
    RadioGroupValueType["String"] = "string";
    RadioGroupValueType["Number"] = "number";
    RadioGroupValueType["Boolean"] = "boolean";
    return RadioGroupValueType;
}({});
export var RadioGroupOptions = /*#__PURE__*/ function(RadioGroupOptions) {
    RadioGroupOptions["Yes"] = "common.inputs.yes";
    RadioGroupOptions["No"] = "common.inputs.no";
    return RadioGroupOptions;
}({});
export var radioGroupDefaultOptions = [
    {
        label: "common.inputs.yes",
        value: true
    },
    {
        label: "common.inputs.no",
        value: false
    }
];
export var RadioGroupHookInput = function(_param) {
    var control = _param.control, name = _param.name, label = _param.label, onChange = _param.onChange, _param_required = _param.required, required = _param_required === void 0 ? true : _param_required, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_options = _param.options, options = _param_options === void 0 ? radioGroupDefaultOptions : _param_options, _param_valueType = _param.valueType, valueType = _param_valueType === void 0 ? "boolean" : _param_valueType, formLabelSx = _param.formLabelSx, defaultValue = _param.defaultValue, _param_helperTextEnabled = _param.helperTextEnabled, helperTextEnabled = _param_helperTextEnabled === void 0 ? true : _param_helperTextEnabled, radioSx = _param.radioSx, rest = _object_without_properties(_param, [
        "control",
        "name",
        "label",
        "onChange",
        "required",
        "disabled",
        "options",
        "valueType",
        "formLabelSx",
        "defaultValue",
        "helperTextEnabled",
        "radioSx"
    ]);
    var t = useTranslation().t;
    var _useController = useController({
        name: name,
        control: control,
        defaultValue: defaultValue
    }), ref = _useController.field.ref, fieldState = _useController.fieldState, restField = _object_without_properties(_useController.field, [
        "ref"
    ]);
    var errText = useHookFieldError(fieldState, label);
    var handleChange = useCallback(function(event, value) {
        var val = value;
        if (valueType === "boolean") {
            val = stringToBoolean(value);
        } else if (valueType === "number") {
            val = +value;
        }
        if (onChange) {
            onChange(event, val);
        } else {
            restField.onChange(val);
        }
        restField.onBlur();
    }, [
        onChange,
        restField,
        valueType
    ]);
    return /*#__PURE__*/ _jsxs(FormControl, {
        required: required,
        error: !!(fieldState.invalid && fieldState.error),
        children: [
            label ? /*#__PURE__*/ _jsx(CustomFormLabel, {
                className: "remove-focus",
                sx: _object_spread({}, formLabelSx),
                id: "".concat(name, "-label"),
                children: label
            }) : null,
            /*#__PURE__*/ _jsx(RadioGroup, _object_spread_props(_object_spread({}, restField, rest), {
                "aria-labelledby": "".concat(name, "-label"),
                "aria-disabled": disabled,
                value: restField.value === undefined ? null : restField.value,
                onChange: handleChange,
                ref: ref,
                children: options.map(function(opt, index) {
                    var _opt_disabled;
                    return /*#__PURE__*/ _jsx(FormControlLabel, {
                        value: opt.value,
                        label: /*#__PURE__*/ _jsxs(Stack, {
                            direction: "row",
                            columnGap: 1,
                            children: [
                                opt.icon && opt.icon,
                                /*#__PURE__*/ _jsxs(Stack, {
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ _jsx(Typography, {
                                            variant: "body1",
                                            color: "inherit",
                                            children: t(opt.label)
                                        }),
                                        opt.subLabel ? /*#__PURE__*/ _jsx(Typography, {
                                            variant: "body2",
                                            sx: {
                                                color: 'text.secondary'
                                            },
                                            children: opt.subLabel
                                        }) : null
                                    ]
                                })
                            ]
                        }),
                        control: /*#__PURE__*/ _jsx(Radio, {
                            required: required,
                            sx: radioSx
                        }),
                        disabled: (_opt_disabled = opt.disabled) !== null && _opt_disabled !== void 0 ? _opt_disabled : disabled,
                        sx: _object_spread({}, formLabelSx)
                    }, index);
                })
            })),
            helperTextEnabled && errText ? /*#__PURE__*/ _jsx(FormHelperText, {
                children: errText
            }) : null
        ]
    });
};
